import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import PrizeMoneyRangeFilter from './FilterComponents/PrizeMoneyRangeFilter';

import styles from '../search.scss';

const EventPrizeMoneyFilter = (props) => {
    const { filters, filterModal, handleFilterClick, closeModals, filterInputs, searchTypes, handleFilterSubmit, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'prizeMoney'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && ((filters.prizeMoneyMin && filters.prizeMoneyMin > 1) || (filters.prizeMoneyMax && filters.prizeMoneyMax < searchTypes.prizeMoneyValues.length))) || filterModal === 'prizeMoney'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Prize Money
            </Filter>
            {filterModal === 'prizeMoney' && (
                <FilterModal
                    title={'Prize Money'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        <PrizeMoneyRangeFilter
                            filterInputs={filterInputs}
                            searchTypes={searchTypes}
                            handlePrizeMoneyChange={(range) => {
                                handleFilterUpdate({
                                    prizeMoneyMin: range[0],
                                    prizeMoneyMax: range[1],
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.range`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default EventPrizeMoneyFilter;
